const BUTTON_VARIANT = "button";
const LINK_VARIANT = "link";
const ACCOUNT_VARIANT = "account";

export { BUTTON_VARIANT, LINK_VARIANT, ACCOUNT_VARIANT };
